<template>
  <b-row>
    <b-col cols="12">
      <team-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import TeamEditForm from './TeamEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    TeamEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
